document.addEventListener('facetwp-loaded', () => {
	let qs = FWP.buildQueryString();
	const resetFilters = document.querySelectorAll('.reset-filters');
	const currentFilter = document.querySelector('.filter-current');
	const resultCount = document.querySelectorAll('.result-count');

	if (currentFilter && resetFilters) {
		if ('' === qs) {
			// no facets are selected
			resetFilters.forEach((elem) => {
				elem.style.display = 'none';
			});
			currentFilter.style.display = 'none';
			currentFilter.parentElement.style.display = 'none';
		} else {
			resetFilters.forEach((elem) => {
				elem.style.display = 'inline-block';
			});
			currentFilter.style.display = 'contents';
			currentFilter.parentElement.style.display = 'block';
		}
	}

	resultCount.forEach((count) => {
		count.innerHTML = '(' + FWP.settings.pager.total_rows + ')';
	});
});
